// extracted by mini-css-extract-plugin
module.exports = {"adSlider":"ads-slider_adSlider__11qV1","adSlider__dots":"ads-slider_adSlider__dots__PVO41","MuiSvgIcon_root":"ads-slider_MuiSvgIcon_root__18J2K"};